export default {
  lastName: {
    unDocumented: {
      issues: [
        {
          id: 'I-DEM-PN-1000',
          domain: 'DPAE'
        }
      ]
    }
  },

  adequateProviderAccess: {
    issues: [
      {
        id: 'I-DEM-PN-1500',
        domain: 'DPAE',
        isDynamic: true,
        dynamicParameters: { lastName: 'lastName' }
      }
    ],
    triggerValue: 'no'
  }
}
